// Types used for requisition packages method

import type { State } from "xstate";
import type {
  PackagesLodgingCompleteBundle,
  PackagesCarCompleteBundle,
  PackagesFlightCompleteBundle,
  PackageType,
  PackageTotalPrice,
} from "../";

export interface PackageShopContext {
  packageType: PackageType;
  packageToken: string;
  totalPrice: PackageTotalPrice;
  bundledProducts: (
    | PackagesLodgingCompleteBundle
    | PackagesCarCompleteBundle
    | PackagesFlightCompleteBundle
  )[];
  selectedDriver: string;
  selectedHotelBooker: string;
}

export const packageShopKey = "packageShop";

export type PackageShopStateType = State<{
  [packageShopKey]: PackageShopContext;
}>;

export type PackageShopStateWithoutValue = Pick<
  PackageShopStateType,
  "context"
>;
